import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Spinner,
  CardImg,
} from "reactstrap";
import { RiAddCircleLine, RiDeleteBinLine } from "react-icons/ri";
import { addCategories, updateCategory } from "service/category.service";
import { useLoader } from "context/LoaderContext";
import { getCategoryById } from "service/category.service";
import ApiClient from "../../api-client";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

const SubcategoryModal = ({ fetchAllSubcategory, isOpen, toggle, subcategoryId }) => {
  console.log(subcategoryId, "subcategoryId1111");
  const dispatch = useDispatch();
  const [categories, setAllCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [subcategoryName, setSubcategoryName] = useState("");
  const [subcategoryDescription, setSubcategoryDescription] = useState("");
  const [subcategoryImage, setSubcategoryImage] = useState();
  const [subcategoryPrevImage, setSubcategoryPrevImage] = useState();
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [removedImages, setRemovedImages] = useState([]);
  const [subcategoryData, setSubcategoryData] = useState([]);

  const getAllCategory = async () => {
    try {
      const getAllCategory = await ApiClient.get(
        `category/get-category?page=${1}&limit=${100}&searchText=`,
        "",
        true,
        dispatch
      );
      const categories = getAllCategory.body.result.map((category) => {
        return {
          categoryId: category._id,
          categoryName: category.categoryName,
        };
      });
      setAllCategory(categories);
      console.log("done");
      if (subcategoryId) {
        console.log("call setSubcategory");
        getSubcategoryById();
      }
    } catch (error) {
      setAllCategory([]);
    }
  };

  const getSubcategoryById = async () => {
    console.log(subcategoryId, "subcategoryId12121");
    if (subcategoryId) {
      try {
        const getData = await ApiClient.get(
          `category/get-subcategory-by-id/${subcategoryId}`,
          "",
          true,
          dispatch
        );
        setSubcategoryData(getData.body);
        setCategoryId(getData.body.categoryId);
        setSubcategoryDescription(getData?.body?.subCategoryDescription);
        setSubcategoryName(getData?.body?.subCategoryName);
        setSubcategoryPrevImage(getData?.body?.subCategoryImageThumbnail?.url);
        console.log(getData, "getData");
      } catch (error) {
        console.log("error: " + error);
      }
    }
  };

  useEffect(() => {
    resetForm()
    getAllCategory();
  }, [subcategoryId]);

  const validate = () => {
    const errors = {};
    if (!categoryId) {
      errors.categoryId = "Category is required";
    }
    if (!subcategoryName) {
      errors.subcategoryName = "Subcategory name is required";
    }
    if (!subcategoryDescription) {
      errors.subcategoryDescription = "Subcategory description is required";
    }
    if (!subcategoryImage && !subcategoryPrevImage) {
      errors.subcategoryImage = "Subcategory image is required";
    } else if(subcategoryImage && subcategoryImage.size / 1000000 > 5) {
      errors.subcategoryImage = "File size should not be greater than 5MB";
    }
    return errors;
  };

  const handleCategoryImageChange = (e) => {
    setSubcategoryImage(e.target.files[0]);
    setSubcategoryPrevImage(URL.createObjectURL(e.target.files[0]));
    if (subcategoryId) {
      setRemovedImages([
        subcategoryData?.subCategoryImage?.key,
        subcategoryData?.subCategoryImageThumbnail?.key,
      ]);
    }
  };

  const resetForm = (saveData) => {
    if (saveData) {
      toggle(saveData);
    }
    console.log('reset');
    setCategoryId("");
    setSubcategoryName("");
    setSubcategoryDescription("");
    setSubcategoryImage("");
    setSubcategoryPrevImage("");
    setLoader(false);
    console.log('reset done');
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      setLoader(true);
      const formData = new FormData();
      formData.append("categoryId", categoryId);
      formData.append("subCategoryName", subcategoryName);
      formData.append("subCategoryDescription", subcategoryDescription);
      formData.append("subCategoryImage", subcategoryImage);

      try {
        let saveData;
        if (subcategoryId) {
          formData.append("id", subcategoryId);
          if (removedImages.length > 0) {
            for (const img of removedImages) {
              formData.append("removedImages", img);
            }
          } else {
            formData.append("removedImages", []);
          }
          saveData = await ApiClient._putFormData(
            `category/update-subcategory`,
            formData,
            true,
            dispatch
          );
        } else {
          saveData = await ApiClient._postFormData(
            `category/add-subcategory`,
            formData,
            true,
            dispatch
          );
        }
        resetForm(saveData);
        toast.success(saveData.message, { autoClose: 3000 });
        fetchAllSubcategory()
      } catch (error) {
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };

  const handleChange = (e) => {
    console.log(e.target.value, 'e.target.value');
  setCategoryId(e.target.value)
  }
  console.log(subcategoryPrevImage, "subcategoryPrevImage");
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {subcategoryId ? "Update Subcategory" : "Add SubCctegory"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="exampleSelect">Select Category</Label>
            <Input
              id="exampleSelect"
              name="select"
              onChange={handleChange}
              type="select"
              value={categoryId}
            >
              <option value="" disabled selected>
                Select a category
              </option>
              {categories.map((category) => {
                return (
                  <option value={category.categoryId}>
                    {category.categoryName}
                  </option>
                );
              })}
            </Input>
            {errors.categoryId && (
              <div className="error-message">{errors.categoryId}</div>
            )}
          </FormGroup>
          <FormGroup>
            <Label for="categoryName">Subcategory Name</Label>
            <Input
              type="text"
              name="categoryName"
              id="categoryName"
              value={subcategoryName}
              onChange={(e) => setSubcategoryName(e.target.value)}
            />
            {errors.subcategoryName && (
              <div className="error-message">{errors.subcategoryName}</div>
            )}
          </FormGroup>
          <FormGroup>
            <Label for="categoryDescription">Subcategory Description</Label>
            <Input
              type="textarea"
              name="categoryDescription"
              id="categoryDescription"
              value={subcategoryDescription}
              onChange={(e) => setSubcategoryDescription(e.target.value)}
            />
            {errors.subcategoryDescription && (
              <div className="error-message">
                {errors.subcategoryDescription}
              </div>
            )}
          </FormGroup>
          <FormGroup  className='upload_files'>
            <Label for="categoryImage">Subcategory Image</Label>
            <Input
              type="file"
              name="categoryImage"
              id="categoryImage"
              accept=".jpeg, .jpg, .png"
              className="file-input"
              onChange={handleCategoryImageChange}
            />
            {subcategoryPrevImage && (
              <CardImg
                alt="Thumbnail"
                className="img-preview-small"
                src={subcategoryPrevImage}
                top
              />
            )}
            {errors.subcategoryImage && (
              <div className="error-message">{errors.subcategoryImage}</div>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          className="common-button"
          onClick={handleSubmit}
          color="primary"
        >
          {subcategoryId ? "Update Subcategory" : "Add SubCategory"}{" "}
          {loader && <Spinner size="sm" />}
        </Button>{" "}
        <Button color="secondary" onClick={resetForm}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SubcategoryModal;
